import {PayloadAction, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { ICounsellingSessionForm, ICounsellingSessionSlot, ISlotGroupedByDate } from "../interfaces/CounsellingSlot";
import moment from "moment";
import { toast } from "react-toastify";
import apiClient from "../api/apiClient";

interface IFetchCounselling {
    programId: string;
}
interface ProgramCounsellingState {
    loading: boolean;
    error: string | null;
    programCounselling: ISlotGroupedByDate[] | [];
}

const initialState: ProgramCounsellingState = {
    loading: false,
    error: null,
    programCounselling: [],
};

interface IDeleteCounselling {
    counsellingID: string
}

/**
 * Axios request to fetch questions for a given programId
 */
export const fetchCounselling = createAsyncThunk('counselling/fetchCounselling',
    async ({programId}: IFetchCounselling, thunkAPI) => {       
        try {
            const response = await apiClient.get(`/api/v1/programs/${programId}/counsellings`);
            return response.data?.data?.counselingSessions || [];
        } catch (error: any) {
            return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
        }
    }
);

/**
 * AXIOS request for store Counselling
 */
export const storeCounselling = createAsyncThunk('counselling/storeCounselling',
async ({programId,startTime,endTime,duration,selectedDates,zoomLink }: ICounsellingSessionForm, thunkAPI) => {
    try {
        const response = await apiClient.post('/api/v1/counsellings', {
            programId,
            startTime: moment(startTime).format('YYYY-MM-DD hh:mm A'),
            endTime: moment(endTime).format('YYYY-MM-DD hh:mm A'),
            duration,
            selectedDates,
            zoomLink
        });
        toast.success("Slots Created successfully");
        thunkAPI.dispatch(fetchCounselling({programId}));
        return response.data?.data || [];
    } catch (error: any) {
        toast.error("Slots are not created, please try again");
        return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
}
);

/**
 * Axios API request to delete a counselling
 */
export const deleteCounselling = createAsyncThunk('counselling/deleteCounselling',
    async ({ counsellingID }: IDeleteCounselling, thunkAPI) => {
        try {
            const response = await apiClient.delete(`/api/v1/counsellings/${counsellingID}`);
            return response.data?.data?.questions || [];
        } catch (error: any) {
            return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
        }
    }
);

const programCounsellingSlice = createSlice({
    name: "programCounselling",
    initialState,
    reducers: {
        resetState: (state) => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCounselling.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCounselling.fulfilled, (state, action) => {
            state.loading = false;
            state.programCounselling = action.payload;
            state.error = null;
        })
        .addCase(fetchCounselling.rejected, (state, action) => {
            state.loading = false;
            state.error = (action.payload as string) || action.error.message || 'An error occurred';
        });
    },
});

export const { resetState } = programCounsellingSlice.actions;
export default programCounsellingSlice.reducer;